<script setup lang="ts">
/***
 * template to show ticket status badge
 */
import TicketStatusBadge from '@/components/layouts/common-components/TicketStatusBadge.vue';

import type { DataTableCellProps } from './templateTypes';

const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <TicketStatusBadge :status="row.status" />
</template>
